export default __webpack_public_path__ + "static/media/info.27383856.svg";